import styled from 'styled-components';
import {MAIN_COLOR} from "../../globalThemes";

const SectionTitle = styled.p`
    display: inline-block;
    font-family: Roboto Condensed, serif;
    color: ${({color}) => color ?? 'black'};
    font-size: 25px;  
    font-weight: bold;  
    margin-top: 50px;
    border-left: 6px solid ${MAIN_COLOR};
    line-height: 25px;
    padding-left: 10px;
    margin-bottom: 0;
    height: 30px;
    
    @media (max-width: 480px) {
        transform: scale(0.9);
        line-height: 30px;
    }
`;

export default SectionTitle;
